import { Injectable } from "@angular/core";
import { authSelectors } from "@content-platform/web-angular-shared-util-auth";
import { Store } from "@ngrx/store";
import { mergeMap } from 'rxjs';
import { endpointNeedsAdalToken } from "../helpers/endpoint-helper";
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
/**
 * Interceptor for the permission API requests, this adds the authorization token, that should
 * be on every request made to the server.
 *
 * @export
 * @class APIServiceInterceptor
 */
export class MsalInterceptorService {
    constructor(store) {
        this.store = store;
    }
    intercept(request, next) {
        if (!endpointNeedsAdalToken(request)) {
            return next.handle(request);
        }
        const token$ = this.store.select(authSelectors.getInternalUserToken);
        return token$.pipe(mergeMap((token) => {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${token}`
                }
            });
            return next.handle(request);
        }));
    }
    static { this.ɵfac = function MsalInterceptorService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || MsalInterceptorService)(i0.ɵɵinject(i1.Store)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: MsalInterceptorService, factory: MsalInterceptorService.ɵfac }); }
}
//# sourceMappingURL=msal-interceptor.service.js.map